<template>
  <!-- 组件 -->
  <div class="container">
    <slot>
    </slot>
    <slot name="footer"><FootView></FootView></slot>
  </div>
</template>
<script>
  import FootView from './Foot'
  export default {
    components: {
      FootView
    },
    data() {
      return {
        currentNav:''
      }
    },
    methods: {},
    mounted() {}
  };
</script>



// WEBPACK FOOTER //
// src/components/BaseLayout.vue